export default __webpack_public_path__ + "static/media/shopping-cart.inline.0397cefd.svg";